export default "__VITE_ASSET__C4zFrxT5__"